// Pure: apply the quietMode master switch (§8.6). Mirrors the backend
// core.experience.preferences.effective_view. quietMode forces Minimal + no sound +
// reduced motion; otherwise the stored values pass through with calm defaults.
export function effectivePrefsView(prefs = {}) {
  const quiet = !!prefs.quietMode;
  return {
    mode: quiet ? 'Minimal' : (prefs.mode || 'Balanced'),
    sound: quiet ? false : !!prefs.sound,
    reducedMotion: quiet ? 'on' : (prefs.reducedMotion || 'system'),
  };
}
